import { alphaSort } from 'vet-bones/utils';

import { ReduxState } from 'src/store/types';
import { stringToSelectItem } from 'src/utils/select/stringToSelectItem';

export const namedGraphItemsSelector =
  (databaseId: string) => (state: ReduxState) => {
    const namedGraphs = state.databases.databasesById[databaseId]?.namedGraphs;
    if (!namedGraphs) {
      return [];
    }
    return Object.values(namedGraphs)
      .filter((namedGraph) => !namedGraph.isVirtual)
      .map(({ iri }) => stringToSelectItem(iri))
      .sort(alphaSort(({ text }) => text));
  };
